var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { Dialog, Text, Title } from '@homeexchange/panorama';
import { parseISODateString } from '@homeexchange/shared';
import { useToast } from '@homeexchange/design';
import i18n from '../../../i18n';
import { heFetch } from '../../../api/HeFetch';
import { deleteAlert } from '../../../actions/savedSearches';
import FiltersModel from '../../../models/Filters';
import Utils from '../../../utils/utils';
import { trackButtonClick } from '../../../utils/utils-ts';
import StaticMap from '../../widget/StaticMap';
import styles from './savedSearchModal.module.scss';
// The saved bounds are the search map's viewport, so fitting them into that map gives back its zoom.
var searchMapZoom = function (bounds) {
    var map = document.querySelector('.search-map-container .gm-style') ||
        document.querySelector('.search-map-container');
    var rect = map === null || map === void 0 ? void 0 : map.getBoundingClientRect();
    if (!rect || rect.width === 0 || rect.height === 0) {
        return undefined;
    }
    return StaticMap.fitZoom(bounds, rect.width, rect.height);
};
// Layout size, not the bounding rect: the dialog scales in on open.
var useElementSize = function () {
    var ref = useRef(null);
    var _a = useState(null), size = _a[0], setSize = _a[1];
    useEffect(function () {
        var element = ref.current;
        if (!element) {
            return undefined;
        }
        var measure = function () {
            var width = element.offsetWidth, height = element.offsetHeight;
            if (width > 0 && height > 0) {
                setSize(function (current) {
                    return current &&
                        Math.round(current.width) === Math.round(width) &&
                        Math.round(current.height) === Math.round(height)
                        ? current
                        : { width: width, height: height };
                });
            }
        };
        measure();
        var observer = new ResizeObserver(measure);
        observer.observe(element);
        return function () { return observer.disconnect(); };
    });
    return { ref: ref, size: size };
};
var TRACKING_AREA = 'saved_search_confirmation_modal';
var CRITERIA_SEPARATOR = ' · ';
var CRITERIA_EXCLUDES = ['availability', 'bounds', 'home', 'placeId', 'place_id', 'sort', 'duration'];
var durationKindLabels = {
    'week-end': i18n.t('common:duration.weekend'),
    'one-week': i18n.t('common:duration.week'),
    'two-weeks': i18n.t('common:duration.week_plural', { count: 2 }),
    'one-month': i18n.t('common:duration.month')
};
var formatDay = function (date) { return moment(parseISODateString(date)).format('D MMM'); };
var formatDates = function (calendar) {
    var _a;
    var ranges = (calendar === null || calendar === void 0 ? void 0 : calendar.dateRanges) || [];
    if (ranges.length === 0) {
        return null;
    }
    var duration = (_a = calendar === null || calendar === void 0 ? void 0 : calendar.flexibleSearch) === null || _a === void 0 ? void 0 : _a.duration;
    if (duration) {
        var months_1 = ranges.map(function (range) { return moment(parseISODateString(range.from)).format('MMMM YYYY'); });
        return "".concat(durationKindLabels[duration] || duration).concat(i18n.t('search:date_ranges_in', {
            in: months_1.filter(function (month, index) { return months_1.indexOf(month) === index; }).join(', ')
        }));
    }
    return ranges.map(function (range) { return "".concat(formatDay(range.from), " - ").concat(formatDay(range.to)); }).join(', ');
};
var formatGuests = function (guestCriteria) {
    var guests = guestCriteria === null || guestCriteria === void 0 ? void 0 : guestCriteria.guests;
    if (!guests) {
        return null;
    }
    var parts = [
        [guests.adults, 'user:traveler.type_adult', 'user:traveler.type_adult_plural'],
        [guests.children, 'user:traveler.type_child', 'user:traveler.type_child_plural'],
        [guests.babies, 'user:traveler.type_baby', 'user:traveler.type_baby_plural']
    ]
        .filter(function (_a) {
        var count = _a[0];
        return count > 0;
    })
        .map(function (_a) {
        var count = _a[0], one = _a[1], many = _a[2];
        return "".concat(count, " ").concat(i18n.t(count > 1 ? many : one));
    });
    return parts.length > 0 ? parts.join(', ') : null;
};
var formatFilters = function (filters, groups) {
    if (!filters) {
        return [];
    }
    return new FiltersModel(filters, CRITERIA_EXCLUDES).stringify({ groups: groups }).filter(Boolean);
};
export var SavedSearchModal = function (props) {
    var _a;
    var isOpen = props.isOpen, onClose = props.onClose, createdAlert = props.createdAlert, bounds = props.bounds, filters = props.filters, groups = props.groups, onDeleted = props.onDeleted;
    var dispatch = useDispatch();
    var _b = useState(false), isDeleting = _b[0], setIsDeleting = _b[1];
    var showToast = useToast().showToast;
    var preview = useElementSize();
    var _c = useState(undefined), zoom = _c[0], setZoom = _c[1];
    useEffect(function () {
        if (isOpen && bounds) {
            setZoom(searchMapZoom(bounds));
        }
    }, [isOpen, bounds]);
    if (!createdAlert) {
        return null;
    }
    // The saved search arrives as a Backbone model: its fields live on `attributes`, `id` is top-level.
    var savedSearch = createdAlert.attributes || createdAlert;
    var savedSearchId = createdAlert.id || savedSearch.externalId;
    var searchCriteria = savedSearch.searchCriteria || {};
    var title = ((_a = savedSearch.displayInformation) === null || _a === void 0 ? void 0 : _a.title) || savedSearch.place;
    var isCollection = Boolean(Utils.isCollectionWebSite());
    var track = function (text) { return trackButtonClick(TRACKING_AREA, text, isCollection); };
    var criteria = __spreadArray([
        formatDates(searchCriteria.calendar),
        formatGuests(searchCriteria.guestCriteria)
    ], formatFilters(filters, groups), true).filter(Boolean)
        .join(CRITERIA_SEPARATOR);
    var close = function (text) {
        track(text);
        onClose();
    };
    var remove = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    track('delete');
                    setIsDeleting(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, heFetch.delete("/search/saved-searches/".concat(savedSearchId))];
                case 2:
                    _a.sent();
                    dispatch(deleteAlert({ id: savedSearchId }));
                    showToast({
                        status: 'success',
                        text: i18n.t('user:modal_travelWishlist_deleted_toast', {
                            defaultValue: 'Search deleted from your travel wishlist.'
                        })
                    });
                    onDeleted === null || onDeleted === void 0 ? void 0 : onDeleted();
                    onClose();
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    showToast({
                        status: 'error',
                        text: i18n.t('common:error_generic', {
                            defaultValue: 'Something went wrong, please try again.'
                        })
                    });
                    return [3 /*break*/, 5];
                case 4:
                    setIsDeleting(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var edit = function () {
        track('edit');
        window.location.assign("".concat(i18n.t('url:saved_search'), "/").concat(savedSearchId));
    };
    return (React.createElement(Dialog, { isOpen: isOpen, onClose: function () { return close('close'); }, title: i18n.t('user:modal_travelWishlist_saved_title', {
            defaultValue: 'Search saved to your travel wishlist'
        }), closeLabel: i18n.t('common:close'), primaryAction: { label: i18n.t('common:done'), onClick: function () { return close('done'); } }, secondaryAction: {
            label: i18n.t('user:modal_travelWishlist_saved_edit', { defaultValue: 'Edit' }),
            onClick: edit
        }, destructiveAction: {
            label: i18n.t('common:delete'),
            icon: 'Trash',
            isLoading: isDeleting,
            onClick: remove
        } },
        React.createElement("div", { className: styles['content'] },
            React.createElement("div", { className: styles['summary'] },
                React.createElement(Title, { variant: "title-xsmall", color: "primary", as: "p" }, title),
                criteria && (React.createElement(Text, { variant: "body-large", thin: true, color: "secondary" }, criteria))),
            bounds && (React.createElement("div", { ref: preview.ref, className: styles['map-preview'] }, preview.size && (React.createElement(StaticMap, { bounds: bounds, width: preview.size.width, height: preview.size.height, boundsZoom: zoom })))))));
};
